import { render } from "./DesignTab.vue?vue&type=template&id=2b49e36c&scoped=true"
import script from "./DesignTab.vue?vue&type=script&lang=js"
export * from "./DesignTab.vue?vue&type=script&lang=js"

import "./DesignTab.vue?vue&type=style&index=0&id=2b49e36c&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src2531651810/src/givergy_presenter_admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b49e36c"]])

export default __exports__